<template>
  <div class="flag-label" :class="toneClass">
    <span v-if="icon" class="flag-icon" v-html="iconMarkup"></span>
    <span>{{ label }}</span>
  </div>
</template>

<script>
const icons = {
  coffee: '&#9679;',
  sprout: '&#9880;',
  snow: '&#10052;',
  cup: '&#9749;',
  dessert: '&#127856;',
  paw: '&#128062;',
  star: '&#10022;'
}

export default {
  name: 'FlagLabel',
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: '' },
    tone: { type: String, default: 'olive' }
  },
  computed: {
    iconMarkup() {
      return icons[this.icon] || this.icon || ''
    },
    toneClass() {
      return `tone-${this.tone}`
    }
  }
}
</script>
